<style lang="less">
    @import "../../../styles/reset.less";
</style>
<template>
    <div class="copyrightDetails">
        <div class="container">
            <h3 class="page_title">预登记订单详情</h3>
            <!--       横幅状态        -->
            <div v-if="details.copyrightOrder.status=='reject_disable' || details.copyrightOrder.status=='reject_enable' " class="audit_status error">
                <span class="audit_text">{{ '驳回原因：'+ details.copyrightOrder.auditMsg }}</span>
            </div>
            <ul class="details_group">
                <li class="details_item">
                    <h3 class="details_group_title">作品基本信息
                        <!--                        <span v-if="downloadFlag" @click="downloadHandle" class="title_right">下载作品文件</span>-->
                    </h3>
                    <ol class="details_content_item">
                        <li class="details_content_item_list">
                            <span class="item_list_title">作品名称：</span><span class="item_list_content">{{details.copyrightOrder.workFullName}}</span>
                            <span class="item_list_title">作品类型：</span><span class="item_list_content">{{details.copyrightOrder.workType}}</span>
                        </li>
                        <li class="details_content_item_list">
                            <span class="item_list_title">作&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;者：</span><span
                                class="item_list_content">{{ details.copyrightOrder.authorNames }}</span>
                            <span class="item_list_title">著作权人：</span><span>{{ details.copyrightOrder.powerNames }}</span>
                        </li>
                        <li class="details_content_item_list">
                            <!--                        <span class="item_list_title">权利取得：</span>   <span class="item_list_content">{{ details.powerBy == 1? '原始取得' : details.powerBy == 2 ? '承受' : details.powerBy == 3 ? '继承' : details.powerBy == 4 ? '其他' :''  }}</span>-->
                            <span class="item_list_title">作品创作性质：</span><span class="item_list_content">{{details.copyrightOrderInfo.creativeType}}</span>
                            <!--                            <span class="item_list_title">权利归属：</span><span>{{ details.copyrightType == 1 ? '个人作品' : details.copyrightType == 2 ? '合作作品' : details.copyrightType == 3 ? '法人作品' : details.copyrightType == 4 ? '职务作品' : details.copyrightType == 5 ? '委托作品' : '' }}</span>-->
                            <span class="item_list_title">权利归属：</span><span>{{ details.copyrightOrder.copyrightType}}</span>
                        </li>
                    </ol>
                </li>
                <li class="details_item">
                    <h3 class="details_group_title">作品创作信息</h3>
                    <ol class="details_content_item">
                        <li class="details_content_item_list">
                            <!--                            <span class="item_list_title">创作开始时间：</span>-->
                            <!--                            <span class="item_list_content">{{ details.completeBegin ? details.completeBegin : ''  }}</span>-->
                            <span class="item_list_title">创作完成时间：</span><span class="item_list_content">{{ details.copyrightOrderInfo.completeDateEnd ? details.copyrightOrderInfo.completeDateEnd : '' }}</span>
                            <span class="item_list_title">创作地点：</span><span class="item_list_content">{{(details.copyrightOrderInfo.completeCountry ? details.copyrightOrderInfo.completeCountry : '')
                        + (details.copyrightOrderInfo.completeProvince ? '-' + details.copyrightOrderInfo.completeProvince  : '' ) + (details.copyrightOrderInfo.completeCity ? '-' + details.copyrightOrderInfo.completeCity  : '' ) }}</span>
                        </li>
                        <!--                        <li class="details_content_item_list">-->
                        <!--                            <span class="item_list_title">创作地点：</span><span class="item_list_content">{{(details.completeCountry ? details.completeCountry : '') + (details.completeProvince ? '-' + details.completeProvince  : '' ) + (details.completeCity ? '-' + details.completeCity  : '' ) }}</span>-->
                        <!--                            <span class="item_list_title">修改次数：</span><span>{{ details.modifyNum ? details.modifyNum : '' }}</span>-->
                        <!--                        </li>-->
                    </ol>
                </li>
                <li class="details_item">
                    <h3 class="details_group_title">作品发表信息</h3>
                    <ol class="details_content_item">
                        <li class="details_content_item_list">
                            <span class="item_list_title">发表状态：</span><span class="item_list_content">{{ details.copyrightOrderInfo.publishStatus == '1' ? '已发表' : '未发表' }}</span>
                            <span class="item_list_title">首次发表时间：</span><span class="item_list_content">{{ details.copyrightOrderInfo.publishStatus == '1' ?  details.copyrightOrderInfo.publishDate && details.copyrightOrderInfo.publishDate!='' ? details.copyrightOrderInfo.publishDate : '' : '-'  }}</span>
                        </li>
                        <li class="details_content_item_list">
                            <span class="item_list_title">首次发表地点：</span><span class="item_list_content">{{(details.copyrightOrderInfo.publishStatus == '1' ?  (details.copyrightOrderInfo.publishCountry ? details.copyrightOrderInfo.publishCountry : '' ) + (details.copyrightOrderInfo.publishProvince ? '-' + details.copyrightOrderInfo.publishProvince : '' )+ (details.copyrightOrderInfo.publishCity ? '-' + details.copyrightOrderInfo.publishCity : '') : '-')   }}</span>
                        </li>
                    </ol>
                </li>


                <li v-if="worksAttachments.length>0" class="details_item">
                    <h3 class="details_group_title">作品文件</h3>
                    <ol class="details_content_item" style="overflow-x: auto;">
                        <!--                        <li class="details_content_item_list">-->
                        <!--                            <p>未经合法授权，任何单位和个人不得进行复制、转载、改编或其它侵权行为。</p>-->
                        <!--                        </li>-->
                        <li class="details_content_item_list img_group">
                            <div v-for="(item,index) in worksAttachments" class="item_list_img">
                                <!--                                <img src="@/assets/file_icon2.png" alt="">-->
                                <img :src="[item.isIcon?item.url:default_icon]" alt="" @click="workDownLoad(item)" >
                                <a :href="item.url" target="_blank" :download="item.name" class="item_list_desc download_class" style="cursor:pointer;">{{item.name}}</a>
                            </div>
                        </li>
                    </ol>
                </li>

              <li v-if="creativeStatementUrls.length>0" class="details_item">
                <h3 class="details_group_title">创作性质授权书</h3>
                <ol class="details_content_item">
                  <li class="details_content_item_list img_group">
                    <div v-for="(item,index) in creativeStatementUrls" class="item_list_img">
                      <!--                                <img src="@/assets/file_icon2.png" alt="">-->
                      <img :src="[item.isIcon?item.url:default_icon]" alt="" @click="workDownLoad(item)" style="cursor: pointer;" target="_blank">
                      <a :href="item.url" target="_blank" class="item_list_desc download_class">{{item.name}}</a>
                    </div>
                  </li>
                </ol>
              </li>

                <li v-if="otherAttachments.length>0" class="details_item">
                    <h3 class="details_group_title">其他证明材料</h3>
                    <ol class="details_content_item">
                        <li class="details_content_item_list img_group">
                            <div v-for="(item,index) in otherAttachments" class="item_list_img">
                                <!--                                <img src="@/assets/file_icon2.png" alt="">-->
                                <img :src="[item.isIcon?item.url:default_icon]" alt="" @click="workDownLoad(item)" style="cursor: pointer;" target="_blank">
                                <a :href="item.url" target="_blank" class="item_list_desc download_class">{{item.name}}</a>
                            </div>
                        </li>
                    </ol>
                </li>

                <li v-if="DecFile.length>0" class="details_item">
                    <h3 class="details_group_title">创作声明</h3>
                    <ol class="details_content_item">
                        <li class="details_content_item_list">
                            <p>未经合法授权，任何单位和个人不得进行复制、转载、改编或其它侵权行为。</p>
                        </li>
                        <li class="details_content_item_list img_group">
                            <div v-for="(item,index) in DecFile" class="item_list_img">
                                <!--                                <img src="@/assets/file_icon2.png" alt="">-->
                                <img :src="[item.isIcon?item.url:default_icon]" @click="workDownLoad(item)" alt="" style="cursor: pointer;" target="_blank">
                                <a :href="item.url" target="_blank" class="item_list_desc download_class">{{item.name}}</a>
                            </div>
                        </li>
                    </ol>
                </li>

                <li  v-if="powerScopes.length>0"  class="details_item">
                    <h3 class="details_group_title">权益拥有情况</h3>
                    <ol class="details_content_item">
                        <li class="details_content_item_list layout">
                            <div v-for="(item,index) in powerScopes" class="item_list_img">
                                <p class="item_list_desc">{{item}}</p>
                            </div>
                        </li>
                    </ol>
                </li>

<!--                <li v-if="details.creationIntentions" class="details_item">
                    <h3 class="details_group_title">创作意图</h3>
                    <ol class="details_content_item">
                        <li class="details_content_item_list">
                            <p class="item_list_paragraph">{{ details.creationIntentions ? details.creationIntentions :'' }}</p>
                        </li>
                    </ol>
                </li>-->

                <li v-if="details.copyrightOrderInfo.creationProcess" class="details_item">
                    <h3 class="details_group_title">创作过程及独创性</h3>
                    <ol class="details_content_item">
                        <li class="details_content_item_list">
                            <p class="item_list_paragraph">{{ details.copyrightOrderInfo.creationProcess ? details.copyrightOrderInfo.creationProcess : '' }}</p>
                        </li>
                    </ol>
                </li>
<!--              -->

<!--              -->
            </ul>

<!--          -->
          <div>
            <h3 class="details_group_title" style="background: #F8F8F8;line-height: 51px;font-size: 14px;padding-left: 20px;margin-bottom: 30px;">证书</h3>
            <ul style="display: flex">
              <li class="details_content_item_list" style="display: flex;float: none;flex: 1">
                <img style="height: 212px" :src="ydj_img"/>
                <div style="marginLeft: 15px">
                  <div  style="fontSize: 16px;font-weight: 700">预登记证书</div>
                  <div style="marginTop: 16px">
                    <div style="fontSize: 14px;font-weight: 700">证书状态：</div>
                    <div style="fontSize: 14px;font-weight: 700;color: #999;margin-top: 4px">{{details.beforeCopyrightCert.certStatus == 'success'?'已认证':'未认证'}} </div>
                  </div>
                  <div style="margin-top: 16px" v-if="details.beforeCopyrightCert.certCode">
                    <div style="fontSize: 14px;font-weight: 700">证书编号：</div>
                    <div style="fontSize: 14px;font-weight: 700;color: #999;marginTop: 4px">{{details.beforeCopyrightCert.certCode?details.beforeCopyrightCert.certCode:''}}</div>
                  </div>

                  <a :href="details.beforeCopyrightCert.certUrl" download v-if="details.beforeCopyrightCert.certUrl" target="_blank">
                    <div class="btn2">查看证书</div>
                  </a>
                </div>
              </li>

              <li class="details_content_item_list" style="display: flex;float: none;flex: 1">
                <img style="height: 212px" :src="yuw_img" v-if="details.copyrightOrder.status == 'wait_identify' && details.copyrightOrder.urgentDayType == null"/>
                <img style="height: 212px" :src="yus_img" v-if="details.copyrightOrder.status == 'identifying' || (details.copyrightOrder.status == 'wait_identify' && details.copyrightOrder.urgentDayType != null)"/>
                <img style="height: 212px" :src="ybh_img" v-if="details.copyrightOrder.status == 'reject_enable'"/>
                <img style="height: 212px" :src="ybu_img" v-if="details.copyrightOrder.status == 'reject_disable'"/>
                <img style="height: 212px" :src="yucheng_img" v-if="details.copyrightOrder.status == 'identify'"/>

                <div style="margin-left: 15px">
                  <div style="font-size: 16px;font-weight: 700">登记证书</div>
                  <div style="marginTop: 16px;" v-if="details.copyrightOrder.auditStatus != 'reject_enable' && details.copyrightOrder.auditStatus != 'reject_disable'">
                    <div style="font-size: 14px;font-weight: 700">登记号：</div>
                    <div style="font-size: 14px;font-weight: 700;color: #999;margin-top: 4px">{{details.copyrightOrderCert.certCode}}</div>

                    <div style="fontSize: 14px;font-weight: 700">登记时间：</div>
                    <div style="fontSize: 14px;font-weight: 700;color: #999;marginTop: 4px" v-if="details.beforeCopyrightTsc != null">{{details.beforeCopyrightTsc.ts}}</div>
                  </div>
                  <div class="btn2" ref="bottom" v-if="details.copyrightOrder.status == 'wait_identify' && details.copyrightOrder.urgentDayType == null" @click="getUrgenDayTypeNum()">一键申请登记证书</div>
                  <a :href="details.copyrightOrderCert.certUrl" download v-if="details.copyrightOrderCert.certUrl && details.copyrightOrder.status == 'identify'" target="_blank">
                    <div class="btn2">查看证书</div>
                  </a>
                </div>
              </li>

            </ul>
          </div>
        </div>

      <Modal title="预登记转登记办理周期" v-model="modalVisible" :mask-closable='false' :width="700" :height="700">
        <div class='inputBtn' style="white-space: nowrap;height: 200px">
          <div v-for="(item,index) in zhouqiData" :class="`${selectZhouqiIndex==index?'item active':'item'}`"  style="width: 210px;display: inline-block; margin-right: 10px;"
               @click="selectOn(index, item.subBizType, item.name, item.num)">

<!--            <div :key={index} :class="`${selectZhouqiIndex==index?'item active':'item'}`"  @click="selectOn(index)" />-->
            <div>
              <div class="t" style="textAlign: center;font-size: 16px">{{item.name}}</div>
              <div style="display: flex;">
                <div style="flex:1;textAlign: center;font-size: 14px">剩余次数：{{item.num}}</div>
              </div>
            </div>
          </div>
          <div style="margin-top: 10px; font-size: 17px; color: red;">
            {{subtractContent}}
          </div>

          <div style="float: right">
            <span class="pay-link" @click="openMonitorBag()">购买加油包</span>
<!--            <span class="pay-link" @click="goGoods()">购买产品</span>-->
          </div>

          <monitorBag :bizType="bizType" :subBizType="type" v-if="monitorBagState" @monitorBagFather="initPayWay();monitorBagState = false"/>


        </div>

        <div slot="footer">
          <Button type="text" @click="closeModal">取消</Button>
          <Button type="primary" @click="updateUrgentDayType">提交</Button>
        </div>
      </Modal>
    </div>
</template>

<script>
    import download from 'ly-downloader'
    import {_getDetail, _updateUrgentDayType} from '../../../api/preRegister'
    import util from "../../../libs/util";
    import { format } from "date-fns";
    import PayWay from '@/views/main-components/pay-way';
    import CertAutorVerify from "../../toReg/cert-autor-verify";
    import DeclareSample from "../../toReg/declareSample";
    import Cookies from "js-cookie";
    import urgentDayTypeBag from '@/views/vipClip/pre/components/urgentDayTypeBag';
    import monitorBag from '@/views/vipClip/monitor/components/monitorBag';

    export default {
      metaInfo: {
          title: '预登记详情|时尚知识产权保护平台',
          meta: [{                 // set meta
              name: 'keyWords',
              content: ''
          }, {
              name: 'Description',
              content: ''
          }]
      },
      name: "preDetails",
      methods: {
        closeModal(){
          this.modalVisible=false;
          clearInterval(this.timer);
          this.timer = null;
        },
        initActivityPayWayList() {
          return this.getRequest("/activityRegisterActivation/list").then(data => {
            if (data.success) {
              const list = data.result;
              if (list && list.length > 0) {
                return Promise.all(list.map(this.findCurrentTypeGift)).then(res => {
                  // 过滤无礼包活动
                  return res.filter(item => item.gift);
                });
              }
            }
          });
        },
        _getPrechargStatus() {
          let aa;
          if(this.code == undefined || this.code == null || this.code == ""){
            if(this.copyrightCode == null || this.copyrightCode == undefined || this.copyrightCode == ""){

            }else{
              aa = this.copyrightCode
            }
          }else{
            aa = this.code
          }
          return this.getRequest("/registerPreRecharge/getStatus?code="+aa).then(data => {
            return data.result
          });
        },


        initPayWay() {
          Promise.all([
            this.initActivityPayWayList(),
            this.initVipRights(),
            this._getPrechargStatus()
          ]).then(res => {
            console.log(res)
            this.list = res[0] || [];
            this.list.unshift({
              activityName: '会员权益支付',
              gift: {
                countNumber: res[1],
                isVipRight: true,
              }
            })
            console.log(this.code)
            console.log(this.copyrightCode)
            if(this.code == undefined || this.code == null || this.code == ""){
              console.log(this.copyrightCode)
              if(this.copyrightCode == null || this.copyrightCode == undefined || this.copyrightCode == ""){

              }else{
                if(res[2] == null || res[2]==""){
                  //
                }else{
                  this.list.splice(2, 0,{
                    activityName: '预存权益支付',
                    id: "1111111",
                    gift: {
                      countNumber: Number(res[2].amount)/100 - Number(res[2].price)/100,
                      isVipRight: false,
                      yue:Number(res[2].amount)/100,
                      price:Number(res[2].price)/100,
                      isHasYe:Number(res[2].amount)/100 - Number(res[2].price)/100
                    }
                  });
                  console.log(Number(res[2].amount)/100 - Number(res[2].price)/100)
                }
              }
            }else{
              if(res[2] == null || res[2]==""){
                //
              }else{
                this.list.splice(2, 0,{
                  activityName: '预存权益支付',
                  id: "1111111",
                  gift: {
                    // countNumber: Number(res[2].amount)/100,
                    // isVipRight: false,
                    // price:Number(res[2].price)/100,
                    // isHasYe:Number(res[2].amount)/100 - Number(res[2].price)/100
                    countNumber: Number(res[2].amount)/100 - Number(res[2].price)/100,
                    isVipRight: false,
                    yue:Number(res[2].amount)/100,
                    price:Number(res[2].price)/100,
                    isHasYe:Number(res[2].amount)/100 - Number(res[2].price)/100
                  }
                });
              }
            }
            // this.list[0].selected = true;
            const shouldSelect = this.list.find(item => item.gift && item.gift.countNumber > 0);
            if (shouldSelect) {
              console.log(shouldSelect)
              shouldSelect.selected = true
              this.$emit('onselected', shouldSelect)
            }
            else{
              this.$emit('onselected', null)
            }
            // for(let i in this.list){
            //   if(this.list[i].selected == true){
            //     if(this.list[i].activityName == "预存权益支付"){
            //       this.preRechargeFlagStr = 1;
            //     }else{
            //       this.preRechargeFlagStr = 0;
            //     }
            //   }
            // }
          })
        },
        timers(){
          this.timer = setInterval(this.initVipRights, 5000);//定时查询购买的产品次数
        },
        openMonitorBag(){
          this.monitorBagState = true;
          this.timers();
        },

        goGoods(){
          this.timers();

          let routeData = this.$router.resolve({ path: '/goods' });
          window.open(routeData.href, '_blank');
        },
        handlePayWaySelect(e) {
          this.payWay = e;
          if(e == null){
            this.isPreRechargeFlag = 0
          }else{
            if(e.activityName == "预存权益支付"){
              this.isPreRechargeFlag = 1
            }else{
              this.isPreRechargeFlag = 0
            }
          }
        },
        OpeningBtn(){
          this.modalState = false;
          this.shopState = true;
        },
        renewBtn(){
          this.modalState = false;
          let routeData = this.$router.resolve({ path: '/goods' });
          window.open(routeData.href, '_blank');
        },
        selectOn(index, subBizType, name, num){
          this.selectZhouqiIndex  = index;
          this.urgentDayType = subBizType

          let content = '该办理周期剩余次数为0，请购买加油包'
          if(num != 0){
            content = '本次扣除1次' + name + '次数'
          }
          this.subtractContent = content;
          this.residueCount = num;
        },
        beforeDestroy() {
          clearInterval(this.timer);
          this.timer = null;
        },
        updateUrgentDayType(){
          clearInterval(this.timer);
          this.timer = null;

          if (this.residueCount == 0) {
            toast('该办理周期剩余次数为0，请购买加油包')
            return false
          }
          this.modalVisible=false
          let paramsData = {
            orderSeqNo: this.copyrightDetailsId,
            urgentDayType: this.urgentDayType,
          }
          _updateUrgentDayType(paramsData).then((res)=>{
            if(res.code){
              toast('登记成功')
            }else{
              toast('登记失败')
            }
            this.getDetail();
            /*if(this.state.zhouqiData.length > 0 && this.state.zhouqiData[this.state.paytypeIdx].residueCount > 0) {
              this.postSubtractCount()
            } else {
              this.setState({
                newPayModal: true,
                newPayModal1: false
              })
              this.getPayInfoByOrderSeqNo()
            }*/

          })
        },
        /************获取预登记详情***********/
        getDetail() {
          let data = {orderSeqNo: this.copyrightDetailsId};
          _getDetail(data).then(res => {

            if (res.code == 200) {
              this.details = res.result;
              let cde = this.details.copyrightOrderInfo.completeDateEnd;
              if(cde != '') {
                cde = format(new Date(Date.parse(cde.replace(/-/g,  '/'))), "YYYY-MM-DD")
                this.details.copyrightOrderInfo.completeDateEnd = cde
              }

              let pd = this.details.copyrightOrderInfo.publishDate;
              if(pd != '' && pd != null) {
                pd = format(new Date(Date.parse(pd.replace(/-/g,  '/'))), "YYYY-MM-DD")
                this.details.copyrightOrderInfo.publishDate = pd
              }
              /*let status = this.details.copyrightOrderInfo.publishStatus ;
              if(status == "未发表")
              {
                this.details.copyrightOrderInfo.publishStatus = "0"
              }else{
                this.details.copyrightOrderInfo.publishStatus = "1"
              }*/
              this.checkDownloadUrl();
              this.DecFileFuc();
              this.worksAttachmentFun();
              this.otherAttachmentsFun();
              this.creativeStatementUrlsFun();
              this.powerScopeFun() ;
              // this.cerImgPrivateUrlFun();
            }
          }, (err) => {
            toast('网络断开连接，请重试')
          })
        },

        /**********校验下载链接********/
        checkDownloadUrl(){
          let downloadList = this.details.copyrightOrder.url.split(',');
          if(downloadList && downloadList.length>0){
            let reUrl01 = /^((ht|f)tps?):\/\/([\w-]+(\.[\w-]+)*\/?)+(\?([\w\-\.,@?^=%&:\/~\+#]*)+)?$/;
            let downloadFlag = false;

            for(let i=0;i<downloadList.length; i++){
              if(!reUrl01.test(downloadList[i])){
                downloadFlag = false;
                break
              }
              else{
                downloadFlag = true;
              }
            }
            this.downloadFlag = downloadFlag;
          }

        },

        downloadHandle(){
          let downloadList = this.details.copyrightOrder.url.split(',');
          for(let i = 0; i<downloadList.length; i++){
            download(1, downloadList[i], '作品'+i)
          }
        },

        workDownLoad(item){
          if(!item.isIcon){
            // download(1,item.url,"");

            var a = document.createElement('a');
            a.download = item.name;
            a.href = item.url;
            a.style.display = 'none'
            a.target="_blank";
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
          }else{
            let link = document.createElement("a");
            link.href = item.url ;
            link.download = item.name;
            link.target="_blank";
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

          }

        },

        getUrgenDayTypeNum(){
          this.modalVisible = true;
          this.initVipRights();
        },

        initVipRights() {
          try {
            this.userInfo = JSON.parse(Cookies.get("userInfo"))
            return this.getRequest("/registerVipMemberRights/get").then(data => {
              if (data.success) {
                this.zhouqiData = [];
                this.selectOn(0, 1601,'1工作日下证', data.result.oneCopyrightRegisterNum)
                this.zhouqiData.push({
                  subBizType: '1601',
                  num:data.result.oneCopyrightRegisterNum+'',
                  name:'1工作日下证',
                });
                this.zhouqiData.push({
                  subBizType: '1602',
                  num:data.result.threeCopyrightRegisterNum+'',
                  name:'3工作日下证',
                });
                this.zhouqiData.push({
                  subBizType: '1603',
                  num:data.result.fiveCopyrightRegisterNum+'',
                  name:'5工作日下证',
                });
              }else{
                console.log(JSON.parse(data));
              }
            });
          } catch (error) {
            console.error(error)
          }
        },

        /************作品文件**************/
        worksAttachmentFun(){
          if(this.details.copyrightOrder.url.split(',') != null || this.details.copyrightOrder.url.split(',').length > 0){
            this.worksAttachments = [];

            // let _url = "./images/default_file.png";
            // let _url = require("./images/default_file.png");
            let _isIcon = false ;
            this.details.copyrightOrder.url.split(',').forEach((item,index)=>{
              let suffix = item.split(".").pop();
              // bmp|png|jpg|gif|jpeg
              if(suffix =="png" || suffix=="jpg" || suffix=="bmp" ||suffix=="jpeg" ||suffix =="gif"||
                  suffix =="PNG" || suffix=="JPG" || suffix=="BMP" ||suffix=="JPEG"||suffix=="GIF" ){
                _isIcon = true ;
              }
              this.worksAttachments.push({
                url:util.thumbnail(item),
                isIcon:_isIcon,
                name:"作品"+(index+1)+"."+suffix
              })
            })
          }
        },
        /************创作性质授权书**************/
        creativeStatementUrlsFun(){
          let csu = this.details.copyrightOrderInfo.creativeStatementUrl.split(',');
          if(csu != null && csu.length > 0 && csu[0] != ""){
            this.creativeStatementUrls = [];
            let _isIcon = false ;
            csu.forEach((item,index)=>{
              let suffix = item.split(".").pop();
              if(suffix =="png" || suffix=="jpg" || suffix=="bmp" ||suffix=="jpeg" ||suffix =="gif"||
                  suffix =="PNG" || suffix=="JPG" || suffix=="BMP" ||suffix=="JPEG"||suffix=="GIF" ){
                _isIcon = true ;
              }
              this.creativeStatementUrls.push({
                url:util.thumbnail(item),
                isIcon:_isIcon,
                name:"创作性质授权书"+(index+1)+item.substr(item.length-4,item.length)
              })
            })
          }
        },

        /************其他证明材料**************/
        otherAttachmentsFun(){
          if(this.details.copyrightOrderInfo.otherAttachments != null) {
            let oas = this.details.copyrightOrderInfo.otherAttachments.split(',');
            if (oas != null && oas.length > 0 && oas[0] != "") {
              this.otherAttachments = [];
              // for(let i=0;i<fileList.length; i++){
              //     DecFile.push({name:'职务作品声明文件' + this.fileType(fileList[i]),url:fileList[i]});
              // }
              let _isIcon = false;
              oas.forEach((item, index) => {
                let suffix = item.split(".").pop();
                // bmp|png|jpg|gif|jpeg
                if (suffix == "png" || suffix == "jpg" || suffix == "bmp" || suffix == "jpeg" || suffix == "gif" ||
                    suffix == "PNG" || suffix == "JPG" || suffix == "BMP" || suffix == "JPEG" || suffix == "GIF") {
                  _isIcon = true;
                }
                this.otherAttachments.push({
                  url: util.thumbnail(item),
                  isIcon: _isIcon,
                  name: "其他证明材料" + (index + 1) + item.substr(item.length - 4, item.length)
                })
              })
            }
          }
        },

        /**********创作声明文件********/
        DecFileFuc(){
          let copyrightType ="" ;// this.details.copyrightType;
          let _isIcon = false ;
          this.powers.forEach(item=>{
            if(item.label == this.details.copyrightOrder.copyrightType)
              copyrightType = item.value ;
          })
          let DecFile = [];

          switch (copyrightType) {
              /**
               * 合作作品，职务作品，委托作品，3给才有创作声明， 且只有要给创作声明
               * */
              //合作作品
            case  '2':{
              let fileList = this.details.copyrightOrderInfo.workCorporate.split(',');
              for(let i=0;i<fileList.length; i++){
                let suffix = fileList[i].split(".").pop();
                if(suffix =="png" || suffix=="jpg" || suffix=="bmp" ||suffix=="jpeg" ||suffix =="gif"||
                    suffix =="PNG" || suffix=="JPG" || suffix=="BMP" ||suffix=="JPEG"||suffix=="GIF" ){
                  _isIcon = true ;
                }

                DecFile.push({
                  url:fileList[i],
                  isIcon:_isIcon,
                  name:'合作作品声明文件' + this.fileType(fileList[i]),
                });
              }
              break;
            }

              //职务作品
            case '4':{
              let fileList = this.details.copyrightOrderInfo.workCorporate.split(',');
              for(let i=0;i<fileList.length; i++){
                let suffix = fileList[i].split(".").pop();
                if(suffix =="png" || suffix=="jpg" || suffix=="bmp" ||suffix=="jpeg" ||suffix =="gif"||
                    suffix =="PNG" || suffix=="JPG" || suffix=="BMP" ||suffix=="JPEG"||suffix=="GIF" ){
                  _isIcon = true ;
                }
                DecFile.push({
                  name:'职务作品声明文件' + this.fileType(fileList[i]),
                  isIcon:_isIcon,
                  url:fileList[i]});
              }
              break
            }

              //委托作品
            case  '5':{
              let fileList = this.details.copyrightOrderInfo.workCorporate.split(',');
              for(let i=0;i<fileList.length; i++){
                let suffix = fileList[i].split(".").pop();
                if(suffix =="png" || suffix=="jpg" || suffix=="bmp" ||suffix=="jpeg" ||suffix =="gif"||
                    suffix =="PNG" || suffix=="JPG" || suffix=="BMP" ||suffix=="JPEG"||suffix=="GIF" ){
                  _isIcon = true ;
                }
                DecFile.push({
                  name:'委托作品声明文件' + this.fileType(fileList[i]),
                  isIcon:_isIcon,
                  url:fileList[i]});
              }
              break;
            }

            default:
              break;
          }
          this.DecFile = DecFile;
        },

        /*******权益拥有情况**********/
        powerScopeFun(){
          // debugger ;
          if(this.details.copyrightOrderInfo.powerScope == null || this.details.powerScope =="")
            return false ;
          this.powerScopes = [];
          this.details.copyrightOrderInfo.powerScope.split(",").forEach(item=>{
            let index = Number(item-1);
            let obj = this.Ownership[index];
            this.powerScopes.push(this.Ownership[index].label);
          })
        },
        /*******证书**********/
        /*cerImgPrivateUrlFun(){
            // debugger ;
            if(this.details.cerImgPrivateUrl != null && this.details.cerImgPrivateUrl.length > 0 && this.details.cerImgPrivateUrl[0] != ""){
                this.cerImgPrivateUrls = [];
                this.details.cerImgPrivateUrl.split(",").forEach((item,index)=>{
                    this.cerImgPrivateUrls.push({
                        url:item,
                    })
                })
            }
        },*/

        /*******************下载证书*******************/
        downLoadDci(){
          let downloadList = this.details.copyrightOrderCert.certUrl;
          download(1,downloadList,'');
        },

        /**********文件类型判断********/
        fileType(filePath){
          //获取最后一个.的位置
          let index= filePath.lastIndexOf(".");
          //获取后缀
          let ext = filePath.substr(index+1);


          return (ext && ext!='' ? '.' + ext : '')
        }



      },
      props: ["type"],
      components: {
        PayWay,
        monitorBag
      },
      data() {
            return {
              monitorBagState: false,
              PayWay:'',
              bizType:'16',
              timer: '',

                urgentDayType:null,
                subtractContent:"",
                selectZhouqiIndex: 0,
                residueCount: 0,
                zhouqiData: [],
                modalVisible: false, // 办理周期弹框显示状态
                urgentDayTypeBagState: false,
                isPreRechargeFlag:null,
                copyrightCode:null,
                userInfo: Cookies.get("userInfo") ? JSON.parse(Cookies.get("userInfo")) : '',
                copyrightDetailsId: '',
                details: [], //登记详情
                downloadFlag:false, //是否可下载
                downloadList:[], //下载列表
                DecFile:[], //创作声明文件
                worksAttachments:[],//作品文件
                otherAttachments:[],//其他证明材料
                creativeStatementUrls:[],//创作性质授权书
                powerScopes:[],
                cerImgPrivateUrls:[],//证书，有2个，
                default_icon:require("../copyrightRegistration/images/default_file.png"),

                ydj_img:require("../copyrightRegistration/images/ydj.png"),
                yus_img:require('../copyrightRegistration/images/yus.png'),
                yucheng_img:require('../copyrightRegistration/images/yucheng.png'),
                ybh_img:require('../copyrightRegistration/images/ybh.png'),
                ybu_img:require('../copyrightRegistration/images/ybu.png'),
                yuw_img:require('../copyrightRegistration/images/yuw.png'),
                /**
                 * 数据库返回的是文字，
                 * */
                powers:[{label:"个人作品",checked:true,value:"1"},{label:"合作作品",checked:false,value:"2"},
                    {label:"法人作品",checked:false,value:"3"},{label:"职务作品",checked:false,value:"4"},
                    {label:"委托作品",checked:false,value:"5"}],
                //权益拥有情况
                Ownership:[
                    { label: '发表权', value: '1',checked:false },
                    { label: '署名权', value: '2' ,checked:false},
                    { label: '修改权', value: '3' ,checked:false},
                    { label: '保护作品完整权', value: '4' ,checked:false},
                    { label: '复制权', value: '5' ,checked:false},
                    { label: '发行权', value: '6' ,checked:false},
                    { label: '出租权', value: '7' ,checked:false},
                    { label: '展览权', value: '8' ,checked:false},
                    { label: '表演权', value: '9' ,checked:false},
                    { label: '放映权', value: '10' ,checked:false},
                    { label: '广播权', value: '11' ,checked:false},
                    { label: '信息网络传播权', value: '12' ,checked:false},
                    { label: '摄制权', value: '13' ,checked:false},
                    { label: '改编权', value: '14' ,checked:false},
                    { label: '翻译权', value: '15',checked:false },
                    { label: '汇编权', value: '16',checked:false },
                    { label: '其他', value: '17',checked:false },
                ],
            }
        },
      watch:{
        "$store.state.app.showPayWay":function(){
          if(this.$store.state.app.showPayWay){
            this.userInfo = JSON.parse(Cookies.get("userInfo")),
                this.flagId = ''
          }
        },
        "copyrightCode":function(){
          this.initVipRights()
        }
      },
      created() {
            if (this.$route.query.id && this.$route.query.id != '') {
                this.copyrightDetailsId = this.$route.query.id;
                this.getDetail();
            }
          this.isLogin = Cookies.get("userInfo")? true : false;
          this.$store.state.app.showPayWay =Cookies.get("userInfo") && Cookies.get("userInfo") != ''? true : false
        }
    }
</script>

<style scoped lang="less">

    .audit_status {
        width: 100%;
        text-align: center;
        height: 50px;
        padding: 15px 0;
        font-size: 14px;
        border: 1px solid #FF8800;
        box-sizing: border-box;
    }

    .audit_status.error {
        background: #ffcccc;
        color: #d81e06;
        border-color: #d81e06;

        .audit_text:before {
            content: '';
            padding-right: 30px;
            height: 20px;
            background: url(../user/more/authentication/images/audit_error.png) no-repeat left center;
            background-size: 20px 20px;
            display: inline-block;
            vertical-align: middle;
        }

    }

    .btn2{
      width: 120px;
      height: 31px;
      background: #FFD800;
      border-radius: 15px 15px 15px 15px;
      line-height: 31px;
      margin-top: 18px;
      font-size: 12px;
      text-align: center;
      color: #333;
      cursor: pointer;
    }


    .copyrightDetails {
        margin: 20px 0 50px;
        background: #FDFDFD;
    }

    .page_title {
        color: #323232;
        background: #fff;
        box-shadow: 0 2px 18px 0 rgba(211, 214, 225, 0.15);
        border-radius: 8px 8px 0 0;
        height: 50px;
        color: #323232;
        font-size: 14px;
        line-height: 50px;
        padding-left: 20px;
    }

    .details_group {
        width: 100%;
        overflow: hidden;
    }

    .layout{
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
    }

    .details_group .details_item:nth-child(odd) .details_content_item {
        background: #fcfcfc;
    }

    .details_group .details_item:last-child .details_content_item {
        background: #fff;
    }



    .details_group .details_group_title {
        color: #323232;
        height: 51px;
        line-height: 51px;
        background: #F8F8F8;
        font-size: 14px;
        padding-left: 20px;
        display: flex;
    }

    .details_group_title .title_right {
        margin-left: auto;
        padding-right: 30px;
        color: #FFA400;
        font-size: 14px;
        cursor: pointer;
    }

    .details_group .details_content_item {
        padding: 20px 40px;
        background: #fff;
    }

    .details_content_item .details_content_item_list {
        display: flex;
        padding-bottom: 20px;
        flex-wrap: wrap;
    }

    .details_content_item .details_content_item_list.img_group {
        white-space: nowrap;
        /*创作声明只有一个了，不用加scroll了*/
        /*overflow-x: scroll;*/
    }

    .details_content_item .details_content_item_list:last-child {
        padding-bottom: 0;
    }

    .details_content_item_list .item_list_title {
        width: 98px;
    }

    .details_content_item_list .item_list_content {
        width: 360px;
    }

    .details_content_item_list .item_list_paragraph {
        width: 690px;
        color: #666666;
        line-height: 20px;
        white-space: normal;
    }

    .details_content_item_list .item_list_img {
        margin-right: 30px;
        text-align: center;
    }

    .item_list_img img {
        display: block;
        width: 256px;
        //height: 168px;
        box-shadow: 0 2px 18px 0 rgba(211, 214, 225, 0.24);
        border-radius: 6px;
        background: #f5f5f5;
        margin: 0 auto;
        object-fit: cover
    }

    .item_list_img .item_list_desc {
        padding-top: 15px;
        padding-bottom: 20px;
        display: block;
        color: inherit;
    }

    .download_class{
        color:rgba(71,73,160,1) !important;
        text-decoration: underline;
    }

    .details_content_item_list .item_list_content:last-child {
        flex: 1;
    }

    .details_content_item_list .cert_box {
        width: 485px;
        text-align: center;
    }

    .cert_box img {
        display: block;
        width: 485px;
        height: 340px;
        background: #f5f5f5;
    }

    .download_btn {
        width:182px;
        height:52px;;
        line-height: 52px;
        background: rgba(71,73,160,1);
        border-radius: 26px;
        color: rgba(255,255,255,1);
        font-size: 18px;
        font-weight:400;
        padding-left: 48px;
        /*margin: 20px auto 0;*/
        margin-left: 40px;
        margin-top: 20px;
        cursor: pointer;
        display: inline-block;
    }

    .inputBoxAll{
      flex: 1;
    }
    .inputBox{
      display: flex;
      align-items: center;
      margin-bottom: 15px;
      .input{
        height: 36px;
        margin: 0 15px;
      }
      .inputBtn{
        width: 170px;
        height: 36px;
        background: #ffd800;
        border-radius: 21px;
        font-size: 14px;
        font-weight: 500;
        color: #4e4e4e;
        outline: none;
        cursor: pointer;
        display: block;
        margin: auto;
      }
    }
    .item{
      display: flex;
      justify-content: center;
      align-items: center;
      border: solid 1px #E5E5E5;
      padding: 8px 15px;
      justify-content: center;
      margin-right: 19px;
      border-radius:4px;
      cursor: pointer;
      flex: 1;
      height: 70px;
      &:last-child{
        margin-right: 0;
      }
      .iocn{
        width: 32px;
        height: 32px;
        margin-right: 5px;
      }
    }
    .active{
      color: #2196F3;
      border: solid 1px #2196F3;
      background-color: rgba(32, 150, 243, 0.1);
    }

    .works_create{
      height: 168px;
      .item{
        height: 168px;
        textarea{
          width: 760px;
          height: 100px;
          padding: 15px;
          resize: none;
        }
      }
    }

    .tit{
      font-size: 14px;
      color: #666;
      line-height: 68px;
      margin-right: 50px;
      float: left;
    }

    .cw_ul_type{
      display:flex;
      justify-content: flex-start;
      margin-top:30px;
      .cw_li_tb{
        margin-right: 20px;
        width: 212px;
        height: 264px;
        background: #ffffff;
        border-radius: 4px;
        border: 1px solid #b9b9b9;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        img{
          margin:20px 0px 20px 20px;
        }
        div{
          height:20px;
          font-size:14px;
          font-weight:400;
          color:rgba(51,51,51,1);
          line-height:20px;
          margin-bottom:10px;
          margin-left:20px;
        }
        p{
          width:172px;
          font-size:12px;
          font-weight:400;
          color:rgba(102,102,102,1);
          line-height:17px;
          margin:0 auto;
        }
      }
    }

    /*.downDciBtn{*/
    /*    width:182px;*/
    /*    height:52px;*/
    /*    background:rgba(71,73,160,1);*/
    /*    border-radius:26px;*/
    /*    font-size:18px;*/
    /*    font-weight:400;*/
    /*    color:rgba(255,255,255,1);*/
    /*    border:none ;*/
    /*    outline: none;*/
    /*    margin-left: 40px;*/
    /*    margin-top: 25px;*/
    /*    cursor: pointer;*/
    /*}*/
    /*.downDciBtn:hover{*/
    /*    background:rgba(71,73,160,0.9);*/
    /*}*/

</style>